/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useState } from 'react';
import { Card, Tab } from '@scuf/common';
import EnergyUsageComponent from './PortfolioEnergyUsage/EnergyUsageComponent/EnergyUsageComponent';
import './EmaasMobileSupervisorPortfolioCard.scss';
import PortfolioEuiComponent from './PortfolioEui/PortfolioEuiComponent';
import { ContextProvider, updateApiConfig } from '../../../context/ApiContext';
import { IEmaaSDataProps, IEmaasPortfolioData } from './IPortfolioProps';
import { useTranslation } from '@scuf/localization';
import { getTabs } from '../../shared/Utils/CommonWidgetUtils';
import PortfolioCarbonComponent from './PortfolioCarbon/PortfolioCarbonComponent';
import { withLocalization } from '../../../locales/withLocalization';
interface IPortfolioToggle {
  activeIndex: number;
  data: IEmaasPortfolioData;
  visibleSites: Array<string>;
  preferredEuiUnit: string | undefined;
  onShowMore: () => void;
  maxRecords: number;
  displayWidgets?: string[];
}
export const showSelctedToggleView = (toggleData: IPortfolioToggle) => {
  const {
    activeIndex,
    data,
    visibleSites,
    preferredEuiUnit,
    onShowMore,
    maxRecords,
    displayWidgets
  } = toggleData;
  const activeWidgetName = displayWidgets![activeIndex];
  if (activeWidgetName == 'carbon') {
    return (
      <div>
        <PortfolioCarbonComponent
          data={data}
          visibleSites={visibleSites}
          onShowMore={onShowMore}
          maxRecords={maxRecords}
          activeWidgetName={activeWidgetName}
        />
      </div>
    );
  }
  if (activeWidgetName == 'energy') {
    return (
      <div>
        <EnergyUsageComponent
          data={data}
          visibleSites={visibleSites}
          onShowMore={onShowMore}
          maxRecords={maxRecords}
          activeWidgetName={activeWidgetName}
        />
      </div>
    );
  }
  if (activeWidgetName == 'eui') {
    return (
      <div>
        <PortfolioEuiComponent
          data={data}
          visibleSites={visibleSites}
          preferredEuiUnit={preferredEuiUnit}
          onShowMore={onShowMore}
          maxRecords={maxRecords}
          activeWidgetName={activeWidgetName}
        />
      </div>
    );
  }
};

function EmaasMobileSupervisorPortfolioWidget(props: IEmaaSDataProps) {
  const {
    data,
    visibleSites,
    emaasContext,
    preferredEuiUnit,
    onShowMore,
    maxRecords,
    displayWidgets
  } = props;
  const [activeIndex, SetactiveIndex] = useState(0);
  const [t] = useTranslation();
  return (
    <ContextProvider
      value={updateApiConfig({
        ...emaasContext
      })}
    >
      <div className="emaas-ms-portfolio-kpi-card">
        <Card>
          <Card.Header className="kpi-header-container">
            <div className="kpi-card-tab">
              <Tab
                defaultActiveIndex={0}
                onTabChange={(changeIndex) => SetactiveIndex(changeIndex)}
              >
                {getTabs(t, displayWidgets!).map((tab) => {
                  return tab;
                })}
              </Tab>
            </div>
          </Card.Header>
          <Card.Content className="kpi-content-container">
            <a
              className="kpi-content-container-anchor"
              onClick={(event) =>
                emaasContext?.onPortfolioCardClick &&
                emaasContext?.onPortfolioCardClick(event)
              }
            >
              {showSelctedToggleView({
                activeIndex,
                data,
                visibleSites,
                preferredEuiUnit,
                onShowMore,
                maxRecords,
                displayWidgets
              })}
            </a>
          </Card.Content>
        </Card>
      </div>
    </ContextProvider>
  );
}

export default withLocalization<IEmaaSDataProps>(
  EmaasMobileSupervisorPortfolioWidget
);
